<template>
    <div class="product-content">
        <h2>Produtos da Chico Rei em promoção na Black Friday</h2>
        <span>
            Foi aqui que pediram ofertas especiais? Selecionamos alguns produtos que vão compor a
            nossa Black Friday 2023 para você já ir se preparando.
        </span>
        <div class="product-wrapper">
            <div class="product" v-for="product in productList">
                <div class="img-wrapper">
                    <a v-for="product in product.items" :href="product.url" target="_blank">
                        <img :src="product.image" />
                    </a>
                </div>
                <div class="text-wrapper">
                    <h2 class="my-0">{{ product.title }}</h2>
                    <p>
                        {{ product.description }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PreBlackProductList',
        data() {
            return {
                productList: [
                    {
                        title: 'Camisetas',
                        description:
                            'Mais do que uma peça de roupa, as camisetas são uma maneira criativa de dar voz a suas ideias e carregá-las no peito por onde você for. Aqui, você encontra peças cheias de personalidade, em várias cores, diferentes modelagens e tamanhos que vão do PP ao 4GG. Um mundo de bonitezas pensado para agradar aos mais diferentes gostos e que espera por você em nossa Black Friday.',
                        items: [
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/4633/c58f6580-11eb-11ee-ace2-efcd5b67aa62.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/camiseta/camiseta-santa-rita-lee-4633.html',
                            },
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/18517/fd1fa3a2-3066-11ed-bbbf-5363f251770f.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/camiseta/camiseta-pagodinho-18517.html',
                            },
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/623/9521d980-106c-11ee-841d-8f3f4426cbb8.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/camiseta/o-auto-da-compadecida-623.html',
                            },
                        ],
                    },
                    {
                        title: 'Meias',
                        description:
                            'Cá pra nós, a beleza mora nos detalhes e nossas meias de cano alto estampadas chegam para provar isso. Com diversas opções de estampas e cores, elas são o acessório ideal para compor o seu look, trazendo mais estilo e charme à composição.',
                        items: [
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/21039/2fec6ed0-368f-11ec-bb49-2f22cdb78f5e.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/meia/meia-susuwatari-21039.html',
                            },
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/58042/beae7b20-ef63-11ed-bebf-33a5af9ce76f.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/meia/meia-pe-de-morro-58042.html',
                            },
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/21013/baf30f30-368e-11ec-8138-0f6ce8e1c26f.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/meia/meia-cacto-21013.html',
                            },
                        ],
                    },
                    {
                        title: 'Bolsas, mochilas, pochetes e shoulder bags',
                        description:
                            'Das bolsas maiores, que cabem um mundo de coisas dentro, até as pochetes e shoulder bags, que contam com uma estética mais minimalista, o mundo das bolsas abraça todos os estilos. E por aqui nós acreditamos que um bom acessório faz toda a diferença e, pensando nisso, reunimos todos os estilos em uma única página para te ajudar durante as suas compras de Black Friday.',
                        items: [
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/18573/70088ba0-3ed0-11eb-a7ba-0f220980d715.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/mochila/mochila-cartagena-18573.html',
                            },
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/16920/e61390e0-a4d6-11ea-8cb6-ab0f0c002a1d.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/bolsa/bolsa-jalapao-16920.html',
                            },
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/18583/b2627832-3664-11ec-963a-0f4a13242851.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/bolsa/pochete-salta-18584.html',
                            },
                        ],
                    },
                    {
                        title: 'Canecas',
                        description:
                            'Seja para carregar suas bebidas favoritas ou decorar aquele cantinho da sua casa, as canecas são itens valiosos que deixam nosso dia a dia mais bonito e especial. Na Chico Rei elas dançam entre a música, o cinema, a poesia e até o mundo dos jogos, com estampas únicas e cheias de boniteza.',
                        items: [
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/19591/59ff3e50-9e0f-11eb-8420-1b5866234e46.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/caneca/caneca-deus-me-proteja-19591.html',
                            },
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/21849/cfdf1c72-ddd9-11ec-9e84-dfc05c0a1d24.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/caneca/caneca-a-professora-21849.html',
                            },
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/58839/9fb5ce10-e9e8-11ed-8faf-bb8527b1470f.jpg?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top',
                                url: '/caneca/caneca-explorador-de-morros-58839.html',
                            },
                        ],
                    },
                    {
                        title: 'Poster',
                        description:
                            'Que tal dar um toque de cor às paredes de forma simples e prática? Os pôsteres nos ajudam a transformar nossos cantinhos de um jeito mais do que especial e durante a Black Friday, todos eles estarão com descontos imperdíveis. Aproveite e garanta o seu.',
                        items: [
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/poster/893/poster-hakuna-matata-893-22425.jpg?auto=compress,format&q=65&w=425&h=638&fit=crop&crop=top',
                                url: '/poster/poster-hakuna-matata-893.html',
                            },
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/poster/8419/poster-books-cats-and-coffee-8419-48293.jpg?auto=compress,format&q=65&w=425&h=638&fit=crop&crop=top',
                                url: '/poster/poster-books-cats-and-coffee-8419.html',
                            },
                            {
                                image:
                                    this.$scope.CDN_PRODUCTS +
                                    '/poster/10544/poster-don-t-grow-up-10544-60430.jpg?auto=compress,format&q=65&w=425&h=638&fit=crop&crop=top',
                                url: '/poster/poster-don-t-grow-up-10544.html',
                            },
                        ],
                    },
                ],
            };
        },
    };
</script>
